import React, { useRef, useEffect } from 'react';
import { graphql } from 'gatsby';
import parse from 'html-react-parser';
//@ts-ignore
import * as styles from './onetrustcookiebutton.module.css';

declare global {
    interface Window {
        ketch?: (...args: any[]) => void;
    }
}

interface Props {
    code: {
        value: string;
    };
    kontentItemId?: string;
}

const OneTrustCookieButton: React.FC<Props> = ({ code, kontentItemId }) => {
    const containerRef = useRef<HTMLDivElement>(null);

    const parseCookieButton = (htmlAsString: string) => {
        let html = htmlAsString;
        html = html.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
        html = html.replace(/\n/g, '');
        const cookieButton = parse(html);
        return cookieButton;
    };

    const cookieButton = parseCookieButton(code.value);

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const btn = container.querySelector<HTMLButtonElement>(
            '#ot-sdk-btn, .ot-sdk-show-settings'
        );
        if (!btn) return;

        const handleClick = (e: MouseEvent) => {
            e.preventDefault();
            if (typeof window.ketch === 'function') {
                window.ketch('showExperience');
            }
        };

        btn.addEventListener('click', handleClick);
        return () => btn.removeEventListener('click', handleClick);
    }, []);

    return (
        <>
            <div
                ref={containerRef}
                className={styles.reviews}
                data-kontent-item-id={kontentItemId}
            >
                {cookieButton}
            </div>
        </>
    );
};

export default OneTrustCookieButton;

export const fragmentOneTrustCookieButton = graphql`
    fragment OneTrustCookieButton on kontent_item_component___onetrust_cookie_button {
        elements {
            code {
                value
            }
        }
    }
`;
